import { useCallback, useMemo } from "react";
import { useAppDispatch, useRootState } from "./index";
import { LogDTO, SummaryLogDTO } from "../../types/log";
import {
  trunkGetLogDetail,
  trunkGetSummaryLogList,
  trunkNewLogList,
  trunkGetDocUserLog,
  trunkGetDocUserLogExcel,
} from "../store/log";

// # hooks
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const useLogStore = () => {
  const logState = useRootState((state) => state.logStore);

  const dispatch = useAppDispatch();

  const boundNewLogList = useCallback(
    (reqDto: LogDTO) => dispatch(trunkNewLogList(reqDto)).then(),
    [dispatch]
  );
  const boundGetSummaryLogList = useCallback(
    (reqDto: SummaryLogDTO) => dispatch(trunkGetSummaryLogList(reqDto)).then(),
    [dispatch]
  );
  const boundGetLogDetail = useCallback(
    (req: { logIdList: string[] }) => dispatch(trunkGetLogDetail(req)).then(),
    [dispatch]
  );
  const boundGetDocUserLog = useCallback(
    (reqDto: LogDTO) => dispatch(trunkGetDocUserLog(reqDto)).then(),
    [dispatch]
  );
  const boundGetDocUserLogExcel = useCallback(
    (reqDto: LogDTO) => dispatch(trunkGetDocUserLogExcel(reqDto)).then(),
    [dispatch]
  );
  return {
    logState,
    getNewLogList: boundNewLogList,
    getSummaryLogList: boundGetSummaryLogList,
    getLogDetail: boundGetLogDetail,
    getDocUserLog: boundGetDocUserLog,
    getDocUserLogExcel: boundGetDocUserLogExcel,
  };
};

export default useLogStore;
